import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { UpdateLeadData } from '../../Utils/utils';
import Message from './Message';
import ModalPayoffline from './ModalPayoffline';
import RateTable from './RateTable';

/**
 * show the data
 * show pay now button
 */

const QStatusSrn = () => {
  let params = useParams();
  let [leadDetails, setLeadDetails] = useState({});
  let [remittanceRate, setRemittanceRate] = useState({});
  let [products, setProducts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const openModal = () => {
    setIsModalOpen(true);
  };

  const handlePayOffline = () => {
    openModal();
  }

  useEffect(() => {
    (async () => {
      try {
        let response = await UpdateLeadData(params);
        response = response.responseData;
        setRemittanceRate(response?.remittance_rate);
        setProducts(response?.products);
        delete response?.remittance_rate;
        delete response?.products;
        setLeadDetails(response);
      } catch(e) {
        console.log(e);
      }
    })();
  }, []);

  const isQuotExp = leadDetails?.isQuotExpired || false;
  return (
    <>
      <div className="main-div container mrg-t60">
        <Message showMessage={leadDetails?.statusMsg} />
        <RateTable remmitanceData={remittanceRate} leadInfo={leadDetails} params={params} showMessage={leadDetails?.statusMsg} isQuotExp={isQuotExp} handlePayOffline={handlePayOffline} />
      </div>

      <ModalPayoffline isModalOpen={isModalOpen} remittanceRate={remittanceRate} params={params} closeModal={closeModal} />
    </>
  );
};

export default QStatusSrn;
